import * as types from './actionTypes';
import { getRequest, postRequest, putRequest, patchRequest } from '../../lib/apiUtils';
import { PermissionTypes } from '../../lib/systemVariables';
import { getUserProfileAndPermissions } from './UserProfileActions';

export function getApprovers() {
    return async dispatch => {
        dispatch({ type: types.START_GET_APPROVERS });

        const response = await getRequest("/users/filtered", {
            permissions: [PermissionTypes.ApplicationsApproveFull, PermissionTypes.ApplicationsApproveLimited],
            active: true
        });
        response.data = response.data.records ? response.data.records.map(user => ({
            key: user.userId,
            value: user.name,
            departments: user.departments
        })) : [];

        dispatch({ type: types.GET_APPROVERS, response });
    }
}

export function updateTable(settings) {
    return dispatch => {
        dispatch({ type: types.UPDATE_USERS_TABLE, settings });
    }
}

export function getUsers(page = 1, results = 12, sort = { by: 'name', direction: 'Ascending' }) {
    return async (dispatch, getState) => {
        const settings = { page, results, sort };
        dispatch({ type: types.UPDATE_USERS_TABLE, settings });

        const requestId = ++getState().usersTable.currentRequestId;
        dispatch({ type: types.START_GET_USERS_TABLE_RECORDS, requestId });

        const tableSettings = getState().usersTable;
        const params = {
            verbose: true,
            page: tableSettings.page,
            sortBy: tableSettings.sort.by,
            sortDirection: tableSettings.sort.direction,
            results: tableSettings.resultsView
        };

        const response = await getRequest('/users', params);

        dispatch({ type: types.GET_USERS_TABLE_RECORDS, ...{ response, requestId } });
    };
}

export function getUserDetails(userId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_USER_DETAILS });

        const response = await getRequest(`/users/${userId}`);

        dispatch({ type: types.GET_USER_DETAILS, response });
    };
}

export function getUserPermissions(userId, myPermissions = false) {
    return async dispatch => {
        dispatch({ type: types.START_GET_USER_PERMISSIONS, myPermissions });

        const response = await getRequest(`/users/${userId}/permissions`, null, []);

        dispatch({ type: types.GET_USER_PERMISSIONS, ...{ response, myPermissions } });
    }
}

export function getPermissionsForRole(roleId) {
    return async dispatch => {
        dispatch({ type: types.START_GET_PERMISSIONS_FOR_ROLE });

        const response = await getRequest(`/settings/permissions/${roleId}`, null, []);

        dispatch({ type: types.GET_PERMISSIONS_FOR_ROLE, response });
    }
}

export function clearUserDetailsAndPermissions() {
    return dispatch => dispatch({ type: types.CLEAR_USER_DETAILS_AND_PERMISSIONS });
}

export function createUser(user) {
    return async dispatch => {
        dispatch({ type: types.START_CREATE_USER });

        const response = await postRequest(`/users`, { setPasswordUrl: `${window.location.origin}/set-password`, user });

        dispatch({ type: types.CREATE_USER, response });

        if (response.success)
            dispatch(getApprovers());
    }
}

export function updateUser(userId, user, replacementApproverId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_USER });

        let userObj = { user };
        if (replacementApproverId) userObj.replacementApproverId = replacementApproverId;
        const response = await putRequest(`/users/${userId}`, userObj);

        dispatch({ type: types.UPDATE_USER, response });

        if (response.success) {
            dispatch(getApprovers());
            if (userId === getState().userProfile.profile.data.userId)
                dispatch(getUserProfileAndPermissions(1));
        }
    }
}

export function updateUserDetail(userId, update, replacementApproverId) {
    return async (dispatch, getState) => {
        dispatch({ type: types.START_UPDATE_USER_DETAIL });

        const response = await patchRequest(`/users/${userId}${replacementApproverId ? `?replacementApproverId=${replacementApproverId}` : ''}`, update);

        dispatch({ type: types.UPDATE_USER_DETAIL, response });

        response.recordIdKey = 'userId';
        response.recordId = userId;
        response.update = update;
        dispatch({ type: types.UPDATE_USERS_TABLE_RECORD, response });

        if (response.success) {
            dispatch(getApprovers());
            if (userId === getState().userProfile.profile.data.userId)
                dispatch({ type: types.UPDATE_USER_PROFILE, update }); //no need to reload profile for single property update, can just update the property
        }
    }
}

export function updateCurrentUserDefaultPrinter(defaultPrinterId) {
    return async dispatch => {
        const response = await putRequest('/users/me/default-printer', { defaultPrinterId });

        if (response.success) {
            dispatch({
                type: types.UPDATE_USER_PROFILE,
                update: { defaultPrinterId: response.data.defaultPrinterId }
            });
        }

        return response;
    };
}



// WEBPACK FOOTER //
// ./src/redux/actions/UsersActions.js